<template>
  <v-dialog :value="openDialog" content-class="upsert-products-group" persistent max-width="1200" max-height="750" scrollable>
    <v-card>
      <v-row no-gutters style="overflow-y: auto">
        <v-item-group v-model="window" class="menu-window bg-cinza-l90">
          <v-item v-slot="{ active, toggle }">
            <div>
              <mf-button type="icon" fill icon="fiber_manual_record" color="cinza-0" size="xs" :input-value="active" @click="toggle" />
            </div>
          </v-item>
          <v-item v-if="!appSales" v-slot="{ active, toggle }">
            <div>
              <mf-button type="icon" fill icon="fiber_manual_record" color="cinza-0" size="xs" :input-value="active" @click="toggle" />
            </div>
          </v-item>
          <v-item v-if="!appSales" v-slot="{ active, toggle }">
            <div>
              <mf-button type="icon" fill icon="fiber_manual_record" color="cinza-0" size="xs" :input-value="active" @click="toggle" />
            </div>
          </v-item>
        </v-item-group>
        <v-col>
          <v-window v-model="window" class="elevation-1" vertical>
            <v-window-item>
              <v-card-title>
                <p class="section-title">
                  {{ titleDialog }}
                </p>
              </v-card-title>
              <v-card-subtitle>
                <p class="group-subtitle pa-0 ma-0">
                  Grupos são uma boa forma de facilitar a sua criação de campanhas e também de manter juntos os produtos que você costumar analisár em conjunto.
                  Lembre-se que produtos incluídos aqui precisam estar cadastrados no seu ERP/PDV para serem efetivamente utilizados numa campanha de ofertas.
                </p>
              </v-card-subtitle>
              <v-card-text>
                <v-row class="pa-0">
                  <v-col cols="4" class="text-center">
                    <div class="d-flex align-center flex-column">
                      <mf-upload-image v-model="group.image_url" fileName="group" @snackbar-error="errorImage($event)" @upload="saveImage" />
                      <p class="texto-img texto-corrido mt-3">
                        A imagem é muito importante para grupos que podem ser usados de forma pública, uma vez que sem ela, o consumidor final vê esse grupo sem
                        foto.
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="8">
                    <v-row>
                      <v-col cols="9" class="pb-0">
                        <v-text-field
                          v-model="groupName"
                          outlined
                          dense
                          label="Nome do seu grupo"
                          height="45"
                          placeholder="Tang morango, abacaxi e mamão"
                          :error-messages="validateGroupName"
                          @input="validateGroupName = ''"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pt-0">
                        <span class="group-subtitle-text pb-2">Regras de Exibição</span>
                        <p class="group-subtitle-rules" max-width="300px">
                          Um grupo <b>público</b> é exibido para o consumidor final como <b>uma única oferta</b>, utilizando imagem e descrição do grupo,
                          enquanto um grupo <b>interno</b> é exibido como <b>ofertas separadas</b> no aplicativo, utilizando imagens e descrições dos produtos
                          individualmente.
                        </p>

                        <v-tooltip max-width="250" top :disabled="!appSales">
                          <template v-slot:activator="{ on }">
                            <span v-on="on"> <mf-tabs-button v-model="group.rules_exhibition" :disabled="appSales" size="sm" :buttons="toggleButtons" /> </span>
                          </template>
                          <span>Esse grupo está ativo em uma oferta. Para parar de exibi-lo remova a oferta das lojas que preferir.</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row v-if="!$getAllowedModules()['products_category']">
                      <v-col cols="9" class="py-2">
                        <v-select
                          v-model="group.category"
                          :items="orderBy(categories, 'name')"
                          label="Categoria"
                          hide-details
                          height="45"
                          dense
                          outlined
                          return-object
                          item-text="name"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="9" class="py-2">
                        <span class="group-subtitle-text">Categorias</span>
                        <v-select
                          v-model="group.categories_final_consumer.department"
                          :items="orderBy(categoriesTypes[0], 'name')"
                          class="pt-3"
                          label="Categoria nível 1"
                          height="45"
                          dense
                          hide-details
                          outlined
                          return-object
                          item-text="name"
                          @change="changeDepartments"
                        />
                      </v-col>
                      <v-col cols="9" class="py-2">
                        <v-select
                          v-model="group.categories_final_consumer.category"
                          :items="orderBy(categoriesWithDepartment, 'name')"
                          :disabled="!group.categories_final_consumer.department || Object.keys(group.categories_final_consumer.department).length === 0"
                          label="Categoria nível 2"
                          height="45"
                          dense
                          outlined
                          return-object
                          item-text="name"
                          :error-messages="categoryErrorMessage"
                          :error="showCategoriesValidation ? $v.group.categories_final_consumer.category.$error : false"
                          :hide-details="!categoryErrorMessage"
                          @change="changeCategory"
                        />
                      </v-col>
                      <v-col cols="9" class="py-2">
                        <v-select
                          v-model="group.categories_final_consumer.sub_category"
                          :items="orderBy(subCategoriesWithCategory, 'name')"
                          :disabled="!group.categories_final_consumer.category || Object.keys(group.categories_final_consumer.category).length === 0"
                          label="Categoria nível 3"
                          height="45"
                          dense
                          outlined
                          return-object
                          :hide-details="!subcategoryErrorMessage"
                          item-text="name"
                        />
                      </v-col>
                    </v-row>
                    <span
                      v-if="$getAllowedModules()['products_category'] && showCategoriesValidation"
                      class="clear-button cursor-pointer"
                      @click="removeCategories"
                      >Limpar categorias</span
                    >
                    <span v-if="!$getAllowedModules()['products_category']" class="clear-button cursor-pointer" @click="removeCategory">Limpar categoria</span>
                    <v-row v-if="products.length">
                      <v-col class="products-chips">
                        <p class="group-subtitle-text ma-0 pb-1">Produtos do grupo ({{ products.length }})</p>
                        <p class="group-subtitle-rules mb-1" max-width="300px">
                          Atente-se a produtos que possuem preços diferentes, como packs, na hora de agrupar os mesmos.
                        </p>
                        <v-tooltip max-width="250" top :disabled="!appSales">
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <v-sheet class="mx-2" max-width="600">
                                <v-slide-group v-model="model" class="pt-0" show-arrows multiple>
                                  <v-chip-group active-class="primary--text">
                                    <v-slide-item v-for="(product, index) in products" :key="`${product.name}-${index}`">
                                      <v-chip color="cinza-l90" small :disabled="appSales" close @click:close="remove(index)">
                                        <span>{{ product.sku }} - {{ product.name }}</span>
                                      </v-chip>
                                    </v-slide-item>
                                  </v-chip-group>
                                </v-slide-group>
                              </v-sheet>
                            </span>
                          </template>
                          <span>Não é permitido remover produtos de uma oferta por aqui. Para desativar um produto altere a gestão de ofertas.</span>
                        </v-tooltip>

                        <all-products-menu :products="products" :app-sales="appSales" @remove="remove($event)" />
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-3">
                      <v-col cols="12">
                        <v-tooltip max-width="250" top>
                          <template v-slot:activator="{ on }" :disabled="!appSales">
                            <span v-on="on">
                              <mf-button label="Incluir produtos" :disabled="appSales" outlined @click="window++" />
                            </span>
                          </template>
                          <span>Não é permitido remover produtos de uma oferta por aqui. Para desativar um produto altere a gestão de ofertas.</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="10" class="mt-3">
                        <v-alert v-if="productsError" class="mb-0" color="red" text type="warning" icon="mdi-alert" height="37px">
                          Selecione os produtos que fazem parte desse grupo
                        </v-alert>
                      </v-col>
                      <v-col cols="12">
                        <mf-action-buttons
                          v-if="window === 0 && !appSales"
                          :primary-button="{
                            text: textActionButton,
                            action: createGroup,
                            isVisible: true,
                            isDisabled: deleteLoading,
                            isLoading: loadingImageUpload || createLoading,
                          }"
                          :secondary-button="{
                            text: 'Deletar grupo',
                            action: () => deleteGroup(group._id),
                            isVisible: !isNew,
                            isLoading: loadingImageUpload || deleteLoading,
                            isDisabled: createLoading,
                          }"
                          :cancel-button="{
                            text: 'Cancelar',
                            action: () => (openDialog = false),
                            isVisible: !isNew,
                            isDisabled: createLoading || deleteLoading,
                          }"
                          :extra-button="{
                            text: 'Cancelar',
                            action: () => (openDialog = false),
                            isVisible: isNew,
                            isDisabled: createLoading || deleteLoading,
                          }"
                        />
                        <mf-action-buttons
                          v-if="window === 0 && appSales"
                          class="unset-capitalize-actions"
                          :primary-button="{
                            text: 'Atualizar',
                            action: () => updateAppSalesGroup(),
                            isVisible: true,
                            isDisabled: deleteLoading,
                            isLoading: loadingImageUpload || updateLoading,
                          }"
                          :extra-button="{
                            text: 'Cancelar',
                            action: () => (openDialog = false),
                            isVisible: !isNew,
                            isDisabled: updateLoading || deleteLoading,
                          }"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>
            <v-window-item v-if="!appSales">
              <graphql-search-content
                ref="searchContent"
                :default-import="false"
                :selected-products="products"
                :title-dialog="titleDialog"
                :window="window"
                :filter-duplicate-products="false"
                @confirm-changes="setSelectedItems"
                @cancel="window--"
              >
                <template v-slot:custom-import>
                  <mf-button color="marca-0-l40" text label="Importar lista de produtos" @click="window = 2" />
                </template>
              </graphql-search-content>

              <mf-action-buttons
                v-if="window === 1"
                class="mr-2 pb-3"
                :primary-button="{
                  text: 'Confirmar',
                  action: () => $refs.searchContent.checkValuesAndConfirmChanges(),
                  isVisible: true,
                }"
                :extra-button="{
                  text: 'Cancelar',
                  action: closeDialog,
                  isVisible: true,
                }"
              />
            </v-window-item>
            <v-window-item v-if="!appSales">
              <import-dynamic-csv-card
                ref="importCard"
                v-model="importDialog"
                :return-default-file="false"
                title="Importar produtos"
                import-label="Importar lista de produtos"
                :required-all-of="requiredFields"
                :fields="importFields"
                logic-text="ou"
                :custom-fields="true"
                :custom-fields-with-disabled="fieldsWithDisabled"
                :show-actions="false"
              >
                <template v-slot:custom-button>
                  <mf-button color="marca-0-l40" text label="Buscar Produtos" @click="window = 1" />
                </template>
              </import-dynamic-csv-card>

              <mf-action-buttons
                v-if="window === 2"
                class="mr-2 pb-4 pt-2"
                :primary-button="{
                  text: 'Importar',
                  action: () => $refs.importCard.finish(),
                  isVisible: true,
                }"
                :extra-button="{
                  text: 'Cancelar',
                  action: () => (openDialog = false),
                  isVisible: true,
                }"
              />
            </v-window-item>
          </v-window>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { orderBy, cloneDeep } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { MUTATION_UPSERT_GROUP_PRODUCTS, QUERY_GROUP_NAME_AVAILABILITY, MUTATION_DELETE_GROUP_PRODUCTS } from '../../graphql'
import { MUTATION_UPDATE_GROUP_APP_SALES } from '@/modules/mobile/ofertas/graphql'
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import AllProductsMenu from '../components/AllProductsMenu.vue'

export default {
  components: {
    AllProductsMenu,
    GraphqlSearchContent: () => import('@/components/GraphqlSearchContent.vue'),
    ImportDynamicCsvCard: () => import('@/components/ImportDynamicCsvCard.vue'),
  },
  props: {
    value: {
      default: false,
      type: Boolean,
    },
    appSales: {
      default: false,
      type: Boolean,
    },
    group: {
      type: Object,
      default: () => ({}),
    },
    categoriesTypes: Array,
    categories: Array,
    dialog: Boolean,
    isNew: Boolean,
  },
  data: () => ({
    window: 0,
    groupName: '',
    orderBy: orderBy,
    products: [],
    importDialog: true,
    showAllProducts: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    productsError: false,
    validateGroupName: '',
    selectedColumns: [],
    requiredFields: ['sku', 'ean'],
    rules: 'PRIVATE',
    model: null,
    categoriesWithDepartment: [],
    subCategoriesWithCategory: [],
    openProducts: false,
    loadingImageUpload: false,
  }),
  provide: function () {
    return {
      objectSelected: this.importGroups,
      updateRequiredColumns: this.updateRequiredColumns,
    }
  },
  computed: {
    openDialog: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Interno',
          value: 'PRIVATE',
          active: true,
        },
        {
          id: 1,
          label: 'Público',
          value: 'PUBLIC',
          active: true,
        },
      ]
    },
    categoryErrorMessage() {
      if (!this.showCategoriesValidation) return ''
      if (this.$v.group?.categories_final_consumer?.category?.$error) return 'É necessário selecionar todos os níveis de categorias para avançar.'
      return ''
    },
    showCategoriesValidation() {
      return !!this.group?.categories_final_consumer?.department?._id
    },
    thirdCategoryRequired() {
      return !!this.group?.categories_final_consumer?.category?._id
    },
    titleDialog() {
      return `${this.isNew ? 'Criar' : 'Editar'} grupo`
    },
    textActionButton() {
      return this.isNew ? 'Criar' : 'Salvar'
    },
    importFields() {
      return [
        { text: 'SKU', value: 'sku' },
        { text: 'EAN', value: 'ean' },
      ]
    },
    fieldsWithDisabled() {
      return this.importFields.map((obj) => {
        let disabled = false

        if (this.selectedColumns.includes('sku') || this.selectedColumns.includes('ean')) {
          disabled = true
        } else {
          disabled = Boolean(this.selectedColumns.includes(obj.value))
        }

        return { ...obj, disabled }
      })
    },
  },
  watch: {
    products: {
      handler(value) {
        if (this.productsError && value.length > 0) {
          this.productsError = false
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.group.categories_final_consumer.department !== null) this.categoriesChosen()
    this.setData()
  },
  methods: {
    setData() {
      this.validateGroupName = ''
      this.productsError = false
      if (this.isNew) {
        this.groupName = ''
        this.products = []
        this.showAllProducts = false
        return
      }
      this.appSales ? (this.rules = 'PUBLIC') : (this.rules = 'PRIVATE')
      this.groupName = this.group.name
      this.products = this.group.products
    },
    setSelectedItems({ products }) {
      this.products = products
      this.window--
    },
    remove(index) {
      const products = cloneDeep(this.products)
      products.splice(index, 1)
      this.products = products
    },
    errorImage(error) {
      this.$snackbar(error)
    },
    closeDialog() {
      this.group = {
        image_url: null,
        categories_final_consumer: {
          department: {},
          category: {},
          sub_category: {},
        },
      }
      this.openDialog = false
    },
    categoriesChosen() {
      if (this.group.categories_final_consumer.department != null && Object.keys(this.group.categories_final_consumer.department).length > 0) {
        this.categoriesWithDepartment = this.categoriesTypes[1].filter(
          (item) => item.department_id === this.group.categories_final_consumer.department._id.toString()
        )
      }
      if (this.group.categories_final_consumer.department != null && Object.keys(this.group.categories_final_consumer.department).length > 0) {
        this.subCategoriesWithCategory = this.categoriesTypes[2].filter(
          (item) => item.category_id === this.group.categories_final_consumer.category._id.toString()
        )
      }
    },
    changeDepartments() {
      if (Object.keys(this.group.categories_final_consumer.department).length > 0 || this.group.categories_final_consumer.department !== null) {
        this.categoriesWithDepartment = this.categoriesTypes[1].filter(
          (item) => item.department_id === this.group.categories_final_consumer.department._id.toString()
        )
      }
      this.group.categories_final_consumer.category = null
      this.group.categories_final_consumer.sub_category = null
    },
    changeCategory() {
      if (Object.keys(this.group.categories_final_consumer.department).length > 0 || this.group.categories_final_consumer.department !== null) {
        this.subCategoriesWithCategory = this.categoriesTypes[2].filter(
          (item) => item.category_id === this.group.categories_final_consumer.category._id.toString()
        )
      }
      this.group.categories_final_consumer.sub_category = null
    },
    removeCategories() {
      this.group.categories_final_consumer = {
        department: {},
        category: {},
        sub_category: {},
      }
    },
    removeCategory() {
      this.group.category = null
    },
    filterRepeatedValues(products) {
      return products.reduce((accumulator, currentProduct) => {
        const position = accumulator.findIndex((product) => product.sku === currentProduct.sku)

        if (position === -1) {
          accumulator.push(currentProduct)
        }

        return accumulator
      }, [])
    },
    async saveImage({ base64, filename }) {
      this.loadingImageUpload = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: { base64, filename },
          context: {
            uri: this.$microservicesUrls['upload'],
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.group.image_url = url
          this.loadingImageUpload = false
        })
        .catch(() => {
          this.loadingImageUpload = false
          this.$snackbar({ message: 'Erro ao subir imagem.', snackbarColor: 'error' })
        })
    },
    async createGroup() {
      this.$v.$touch()
      if (!this.products.length || !this.groupName.trim() || this.$v.group.$error) {
        this.validateGroupName = !this.groupName.trim() ? 'Esse campo é obrigatório' : ''
        this.productsError = !this.products.length
        return
      }

      this.createLoading = true
      const filteredProductsArray = this.filterRepeatedValues(this.products)

      try {
        if (this.groupName !== this.group.name) {
          const {
            data: { productsGroupNameAvailability },
          } = await this.$apollo.query({
            query: QUERY_GROUP_NAME_AVAILABILITY,
            variables: {
              name: this.groupName,
            },
          })

          if (!productsGroupNameAvailability) {
            throw new Error('Já existe um grupo usando esse nome')
          }
        }

        let consumerCategories = {}

        if (this.$getAllowedModules()['products_category']) {
          this.group.category = null
          if (this.group.categories_final_consumer.department !== null) {
            consumerCategories = {
              department_id: this.group.categories_final_consumer?.department._id || null,
              category_id: this.group.categories_final_consumer?.category?._id || null,
              sub_category_id: this.group.categories_final_consumer?.sub_category?._id || null,
            }
          }
        } else {
          this.group.categories_final_consumer.department = null
        }

        const variables = {
          _id: this.group._id || undefined,
          name: this.groupName,
          skus: filteredProductsArray.map((product) => product.sku),
          image_url: this.group.image_url,
          rules_exhibition: this.group.rules_exhibition,
          category: this.group?.category?._id || null,
          categories_final_consumer:
            this.group.categories_final_consumer.department !== null && Object.keys(this.group.categories_final_consumer.department).length > 0
              ? consumerCategories
              : null,
        }
        await this.$apollo.mutate({
          mutation: MUTATION_UPSERT_GROUP_PRODUCTS,
          variables: { data: variables },
        })
        if (this.isNew) {
          this.$snackbar({ message: 'Grupo criado com sucesso.', snackbarColor: 'success' })
        } else {
          this.$snackbar({ message: 'Grupo editado com sucesso.', snackbarColor: 'success' })
        }
        this.$emit('close', true)
      } catch (e) {
        if (e.message === 'Já existe um grupo usando esse nome') {
          this.validateGroupName = e.message
          return
        }
        this.$emit('close', true)
        if (this.isNew) {
          this.$snackbar({ message: 'Erro ao criar grupo.', snackbarColor: 'error' })
        } else {
          this.$snackbar({ message: 'Erro ao editar grupo.', snackbarColor: 'error' })
        }
      } finally {
        this.createLoading = false
      }
    },
    async updateAppSalesGroup() {
      this.$v.$touch()
      if (!this.products.length || !this.groupName.trim() || this.$v.$error) {
        this.validateGroupName = !this.groupName.trim() ? 'Esse campo é obrigatório' : ''
        this.productsError = !this.products.length
        return
      }

      this.updateLoading = true

      try {
        const consumerCategories = {
          department_id: this.group?.categories_final_consumer?.department?._id || null,
          category_id: this.group?.categories_final_consumer?.category?._id || null,
          sub_category_id: this.group?.categories_final_consumer?.sub_category?._id || null,
        }

        const variables = {
          _id: this.group._id || undefined,
          name: this.groupName,
          image_url: this.group.image_url,
          categories_final_consumer: this.group.categories_final_consumer.department !== null ? consumerCategories : null,
        }

        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_GROUP_APP_SALES,
          variables: { data: variables },
          context: {
            uri: this.$microservicesUrls['sales'],
          },
        })

        this.$snackbar({ message: 'Grupo editado com sucesso.', snackbarColor: 'success' })
        this.openDialog = false
        this.$emit('close', true)
      } catch (e) {
        this.openDialog = false
        this.$emit('close', true)
        this.$snackbar({ message: 'Erro ao editar grupo.', snackbarColor: 'error' })
      } finally {
        this.updateLoading = false
      }
    },
    deleteGroup(id) {
      this.$confirm({
        title: 'Remover grupo',
        message: 'Tem certeza que deseja remover este grupo? Ele não poderá mais ser usado na criação de campanhas. Essa ação não pode ser desfeita.',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          this.deleteLoading = true

          try {
            await this.$apollo.mutate({
              mutation: MUTATION_DELETE_GROUP_PRODUCTS,
              variables: {
                _id: id,
              },
            })
            this.$snackbar({ message: 'Grupo deletado com sucesso.', snackbarColor: 'success' })
          } catch {
            this.$snackbar({ message: 'Erro ao deletar grupo. Tente novamente mais tarde.', snackbarColor: 'error' })
          } finally {
            this.deleteLoading = false
            this.$emit('close', true)
          }
        })
        .catch(() => {})
    },
    changeIconColor(isNotActive) {
      return isNotActive ? '' : 'cinza-l50'
    },
    updateRequiredColumns(selectedColumns) {
      const filterColumns = selectedColumns.filter((column) => !!column)
      this.selectedColumns = filterColumns

      if (filterColumns.includes('sku') && filterColumns.length === 1) {
        this.requiredFields = ['sku']
      } else if (filterColumns.includes('ean') && filterColumns.length === 1) {
        this.requiredFields = ['ean']
      } else {
        this.requiredFields = ['sku', 'ean']
      }
    },
    importGroups(fileContent) {
      this.window = 1
      const filterPosition = fileContent.selectedColumns.findIndex((column) => column === 'sku' || column === 'ean')
      const ids = fileContent.file.map((line) => line[filterPosition]).filter((element) => /^\d+$/.test(element.trim()))
      let eans
      let skus

      if (fileContent.selectedColumns[filterPosition] === 'ean') {
        eans = ids
      } else {
        skus = ids
      }

      this.$refs.searchContent.getSelectedProducts({ eans, skus })
    },
  },
  validations() {
    const categories_final_consumer = {
      ...(this.showCategoriesValidation && { category: { required } }),
    }

    return {
      group: {
        ...(this.showCategoriesValidation && { categories_final_consumer }),
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.upsert-products-group {
  .group-subtitle {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0.4px;
    color: $cinza-0;
  }
  .group-subtitle-rules {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    max-width: 600px;
    line-height: 120%;
    letter-spacing: 0.4px;
    color: $cinza-0;
  }
  .group-subtitle-text {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.4px;
    color: $cinza-d10;
  }
  .texto-img {
    max-width: 220px;
  }
  .unset-capitalize {
    &-include {
      text-transform: unset !important;
      letter-spacing: $letterspacing-1;
      font-family: 'Lato';
      font-style: normal;
      line-height: 20px;
      font-weight: 400;
      font-size: 12px;
    }
    &-toggles {
      text-transform: unset !important;
      letter-spacing: $letterspacing-1;
      font-weight: 400;
      font-family: 'Lato';
      font-style: normal;
      line-height: 20px;
      font-size: 14px;
    }
    &-actions {
      text-transform: unset !important;
      letter-spacing: $letterspacing-1;
      font-weight: 400;
      font-family: 'Lato';
      font-style: normal;
      line-height: 20px;
      font-size: 18px;
    }
  }
  .clear-button {
    color: $vermelho-d20;
    text-decoration: underline;
  }
  .first-column {
    display: flex;
    flex-direction: column;
    &-btn {
      height: 230px;
      display: flex;
      justify-content: flex-start !important;
      align-content: flex-end;
      right: 30px;
    }
  }
}
.v-btn--active:before {
  opacity: 0;
}
.link {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $marca-0-l40 !important;
  text-transform: none;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}
.bg-cinza-l90 {
  background-color: $cinza-l90;
}

::v-deep .v-sheet .v-alert--text {
  display: flex;
  align-items: center;
}

::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused).v-input--is-disabled > .v-input__control > .v-input__slot fieldset {
  background: $cinza-l90 !important;
}
</style>
